import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useCognito } from '@trading-utils/sso-cognito';

import { appRoutes } from '@/config/appRoutes';

import useBiofluxUser from './useBiofluxUser';

export const useAuthWithRoutePreservation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { isLoggedIn, isLoading: isLoadingCognito, user: cognitoUser } = useCognito();
  const { user: biofluxUser, isLoading: isLoadingBiofluxUser } = useBiofluxUser(cognitoUser?.sub);

  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [preservedPath, setPreservedPath] = useState<string | null>(null);

  useEffect(() => {
    if (isInitialLoad && location.pathname !== '/' && location.pathname !== appRoutes.SIGN_IN) {
      setPreservedPath(location.pathname);
      setIsInitialLoad(false);
    }
  }, [location.pathname, isInitialLoad]);

  useEffect(() => {
    if (isLoadingCognito || isLoadingBiofluxUser) {
      return;
    }

    if (isLoggedIn && biofluxUser && preservedPath) {
      navigate(preservedPath, { replace: true });
      setPreservedPath(null);
    }

    if (!isLoggedIn && preservedPath) {
      setPreservedPath(null);
    }
  }, [isLoggedIn, biofluxUser, isLoadingCognito, isLoadingBiofluxUser, preservedPath, navigate]);

  return {
    isLoggedIn,
    biofluxUser,
    isLoading: isLoadingCognito || isLoadingBiofluxUser,
    cognitoUser,
  };
};

export default useAuthWithRoutePreservation;
